var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"w-100",class:((_vm.vertical ? 'image-area-vertical' : 'image-area') + " " + (_vm.uploadImage.url ? 'preview-image' : null)),style:(_vm.renderImageUrl)})])}
var staticRenderFns = []

export { render, staticRenderFns }